import { render, staticRenderFns } from "./ApprovalButton.vue?vue&type=template&id=8f92dd34&scoped=true&"
import script from "./ApprovalButton.vue?vue&type=script&lang=js&"
export * from "./ApprovalButton.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalButton.vue?vue&type=style&index=0&id=8f92dd34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f92dd34",
  null
  
)

export default component.exports